import cx from 'classnames'
import { ReactNode, CSSProperties } from 'react'
import s from './style.module.scss'

interface IButton {
  children: ReactNode
  as?: 'button' | 'span' | 'div' | 'a'
  className?: string
  style?: CSSProperties
  type?: 'button' | 'submit'
  onClick?: (data?: any) => void
  view?: 'primary' | 'auth' | 'auth-alternative' | 'orange-link' | 'blue-link' | 'auth-back' | 'cancel'
  color?:
    | 'blue'
    | 'blue-dark'
    | 'orange'
    | 'red'
    | 'purple'
    | 'purple-light'
    | 'ghost'
    | 'purple-gradient'
    | 'red-white'
    | 'gray'
  disabled?: boolean
  fluid?: boolean
  href?: string
  target?: '_blank' | '_self'
}

function Button({
  children,
  as: ElementType = 'button',
  className,
  style,
  type = 'button',
  onClick,
  view = 'primary',
  color,
  disabled,
  fluid,
  ...props
}: Readonly<IButton>) {
  const classNames = cx(
    s.button,
    s[`view-${view}`],
    {
      [s[`color-${color}`]]: color,
      [s.fluid]: fluid
    },
    className
  )

  return (
    <ElementType
      className={classNames}
      style={style}
      type={type}
      disabled={disabled}
      onClick={!disabled ? onClick : () => {}}
      {...props}
    >
      {children}
    </ElementType>
  )
}

export default Button
